import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import SignupPage from './pages/SignupPage';
import PricingPage from './pages/PricingPage';
import ApplicationsPage from './pages/ApplicationsPage';
import ConsentPage from './pages/ConsentPage';
import LogoutPage from './pages/LogoutPage';
import DevicePage from './pages/DevicePage';
import ErrorPage from './pages/ErrorPage';
import MFAChallengePage from './pages/MFAChallengePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import PasswordResetPage from './pages/PasswordResetPage';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/applications" element={<ApplicationsPage />} />
      <Route path="/mfa-challenge" element={<MFAChallengePage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<PasswordResetPage />} />
      <Route path="/consent" element={<ConsentPage />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/device" element={<DevicePage />} />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
